export default __webpack_public_path__ + "static/media/schmidt.95e6d948.png";